import { createContext } from 'react';
import { OptInContextType } from '../types/opt-in-context.type';

export const OptInContext = createContext<OptInContextType>({
    openAddYourDeviceDialog: false,
    setOpenAddYourDeviceDialog: () => {},
    openConfirmationDialog: false,
    setOpenConfirmationDialog: () => {},
});
